import { ElementType, ReactNode } from 'react';
import styled from 'styled-components';
import {
  FontFamilyProps,
  FontWeightProps,
  LetterSpacingProps,
  LineHeightProps,
  TextAlignProps,
  fontFamily,
  fontWeight,
  letterSpacing,
  lineHeight,
  textAlign,
} from 'styled-system';
import { BaseStyleProps, base, themed } from '../base';

export interface TextProps
  extends BaseStyleProps,
    FontFamilyProps,
    FontWeightProps,
    TextAlignProps,
    LineHeightProps,
    LetterSpacingProps {
  as?: ElementType;
  content?: ReactNode;
  className?: string;
  id?: string;
  style?: React.CSSProperties;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const TextWrapper = styled('p')<TextProps>(
  base as any,
  fontFamily as any,
  fontWeight as any,
  textAlign as any,
  lineHeight as any,
  letterSpacing as any,
  themed('Text') as any
);
/* eslint-enable @typescript-eslint/no-explicit-any */

const Text = ({
  as = 'p',
  mt = 0,
  mb = '1rem',
  content,
  ...props
}: TextProps) => (
  <TextWrapper as={as} mt={mt} mb={mb} {...props}>
    {content}
  </TextWrapper>
);

export default Text;
